import { useEffect, useRef, useState } from "react";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Demo_Modal from "../../common/demo-modal/Demo_Modal";
import "./Banner.css";

function Banner() {
  const bannerRef = useRef(null);
  const [animateIntro, setAnimateIntro] = useState(false);

  const [active, setActive] = useState(false);
  const scrollLock = useRef(false);

  const touchStartY = useRef(0);
  const touchEndY = useRef(0);
  const touchMoved = useRef(false);

  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    const banner = bannerRef.current;
    if (!banner) return;

    /* ---------- COMMON CTA TRIGGER ---------- */
    const triggerCTA = (state) => {
      scrollLock.current = true;
      setActive(state);

      setTimeout(() => {
        scrollLock.current = false;
      }, 900);
    };

    /* ---------- DESKTOP SCROLL ---------- */
    const handleWheel = (e) => {
      if (window.innerWidth <= 768) return;

      if (scrollLock.current) {
        e.preventDefault();
        return;
      }

      if (e.deltaY > 0 && !active) {
        e.preventDefault();
        triggerCTA(true);
      }

      if (e.deltaY < 0 && active) {
        e.preventDefault();
        triggerCTA(false);
      }
    };

    /* ---------- MOBILE TOUCH ---------- */
    const handleTouchStart = (e) => {
      touchStartY.current = e.touches[0].clientY;
      touchMoved.current = false;
    };

    const handleTouchMove = (e) => {
      touchEndY.current = e.touches[0].clientY;
      touchMoved.current = true;
    };

    const handleTouchEnd = () => {
      if (scrollLock.current) return;

      const swipeDistance = touchStartY.current - touchEndY.current;
      const swipeThreshold = 60;
      const tapThreshold = 10;

      //  TAP (reset to intro)
      if (Math.abs(swipeDistance) < tapThreshold && active) {
        triggerCTA(false);
        return;
      }

      //  SWIPE UP
      if (swipeDistance > swipeThreshold && !active) {
        triggerCTA(true);
      }

      //  SWIPE DOWN
      if (swipeDistance < -swipeThreshold && active) {
        triggerCTA(false);
      }
    };

    banner.addEventListener("wheel", handleWheel, { passive: false });
    banner.addEventListener("touchstart", handleTouchStart, { passive: true });
    banner.addEventListener("touchmove", handleTouchMove, { passive: true });
    banner.addEventListener("touchend", handleTouchEnd);

    return () => {
      banner.removeEventListener("wheel", handleWheel);
      banner.removeEventListener("touchstart", handleTouchStart);
      banner.removeEventListener("touchmove", handleTouchMove);
      banner.removeEventListener("touchend", handleTouchEnd);
    };
  }, [active]);

  useEffect(() => {
    // Trigger animation on page load (refresh)
    setTimeout(() => {
      setAnimateIntro(true);
    }, 100);
  }, []);


  return (
    <>
      <section
        ref={bannerRef}
        className={`home_banner ${active ? "cta" : "intro"}`}
      >
        <div className="container">
          <div className="home_banner_holder">
            <img
              src="/assets/images/home/banner/banner.png"
              alt="banner"
              className="banner"
            />

            {/* INTRO */}
            <div className="home_banner_content_holder intro_content">
              <p className={`welcome_text ${animateIntro ? "slide_in_left" : ""}`}>
                Welcome to
              </p>


              <div className="audio_text_img_holder">
                <img
                  src="/assets/images/home/banner/audio_text.png"
                  alt="audio"
                  className="audio_text_img"
                />
              </div>

              <p className={`started_text ${animateIntro ? "slide_in_right" : ""}`}>
                Let’s get started!
              </p>

            </div>

            {/* CTA */}
            <div className="home_banner_content_holder cta_content">
              <p className="cta_subtitle">
                Schedule a free demo and see how we can transform your workflow.
              </p>

              <h2 className="cta_title">
                One Platform, Endless Possibilities.
              </h2>

              <Common_Btn text="Book Your Demo" onClick={handleOpenModal} />
            </div>
          </div>
        </div>
      </section>

      <Demo_Modal show={showModal} handleClose={handleCloseModal} />
    </>
  );
}

export default Banner;
